.frame {
  position: relative;
  margin: 0;
  height: 100%;
  min-height: 212px;
  background: var(--color-map-land);
}
.map {
  position: absolute;
  inset: 0;
}
.failed {
  position: absolute;
  inset: auto var(--dimension-space-4) 50% var(--dimension-space-4);
  margin: 0;
  text-align: center;
  color: var(--color-text-secondary);
}
/* Required ODbL attribution, bottom-left in type.micro (patterns/maps.md). */
.attribution {
  position: absolute;
  left: var(--dimension-space-2);
  bottom: var(--dimension-space-1);
  padding: 1px 4px;
  background: color-mix(in srgb, var(--color-map-land) 75%, transparent);
  color: var(--color-map-label);
  text-transform: none;
  letter-spacing: 0;
}

/* Pins (patterns/maps.md): 24pt squares, radius 2, day colour with the stop ID in white readout.S. */
.pin {
  min-width: 24px;
  height: 24px;
  padding: 0 4px;
  border: 0;
  border-radius: var(--dimension-radius-xs);
  font-family: var(--font-readout);
  font-size: 0.8125rem;
  font-weight: 500;
  color: white; /* as on iOS: white stop IDs on every day colour */
  cursor: pointer;
}
.day {
  background: var(--color-day-1);
}
.hollow {
  background: var(--color-surface-base);
  border: 2px solid var(--color-border-control);
  color: var(--color-text-primary);
}
.lodging {
  width: 24px;
  background:
    var(--color-text-primary) no-repeat center / 14px
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='2'%3E%3Cpath d='M2 20v-8a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v8M4 10V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4M12 4v6M2 18h20'/%3E%3C/svg%3E");
}
.selected {
  min-width: 32px;
  height: 32px;
  background: var(--color-surface-signal);
  color: var(--color-text-on-signal);
  outline: 1px solid var(--color-text-primary);
}
